import { useCallback, useState, useContext, useRef, useEffect, Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { usePatchReminder, useLogLogout, useGetPopUp, usePostPopUp, usePostLifePopUp } from 'all-in-one-shared-api';
import { Dropdown, Menu, Popover, Typography } from 'antd';

import { osName, osVersion } from 'react-device-detect';
import { useSWRConfig } from 'swr';
import logo from 'assets/images/logo.svg';
import logo2 from 'assets/images/header-white.svg';
import { useBreakpoint, useKeycloakReady } from 'hooks';
import './BravoHeader.less';
import { LogoutButtonIcon } from '../ProfileLayout/components/LogoutButton';
import { HomeContext } from 'contexts/home/context';
import _ from 'lodash';
import { sessionStorageService, SessionStorageKey } from 'utils/SessionStorageService';
import { removeCookie } from 'utils/cookies';
import { UserAccessActionTypes } from '../../../contexts/home/actions';
import { CollapseNav } from '../CollapseNav';
import HomeNavIcon from 'assets/images/liHome/home-nav.svg';
import HomeNotNavIcon from 'assets/images/liHome/Home-not.svg';
import ClaimNavIcon from 'assets/images/liHome/Make-a-Claim.svg';
import ClaimNotNavIcon from 'assets/images/liHome/Make-a-Claim-not.svg';
import BenefitsNavIcon from 'assets/images/liHome/My-Benefits.svg';
import BenefitsNotNavIcon from 'assets/images/liHome/My-Benefits-not.svg';
import PoliciesNavIcon from 'assets/images/liHome/Policies.svg';
import PoliciesNotNavIcon from 'assets/images/liHome/Policies-not.svg';
import SupportNavIcon from 'assets/images/liHome/Support.svg';
import PaymentNavIcon from 'assets/images/liHome/payment-nav.svg';
import PaymentNotNavIcon from 'assets/images/liHome/Payment-not.svg';
import EditNavIcon from 'assets/images/liHome/Edit.svg';
import EditNotNavIcon from 'assets/images/liHome/Edit-not.svg';
import SupportNotNavIcon from 'assets/images/liHome/support-not.svg';
import {
  HelpMenu,
  LanguageSelector,
  Link,
  MenuWrapper,
  CardStyledDivider,
  StyledHeader,
  StyledWrapper,
  DropCard,
  BriefWrapper,
  MobileLang,
  AppLang,
} from './components';

interface MenuInfo {
  key: string;
  keyPath: string[];
  domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
}

const menuItems = [
  { label: 'home', icon: HomeNavIcon, iconN: HomeNotNavIcon },
  { label: 'claims', icon: ClaimNavIcon, iconN: ClaimNotNavIcon },
  { label: 'benefits', icon: BenefitsNavIcon, iconN: BenefitsNotNavIcon },
  { label: 'documents', icon: PoliciesNavIcon, iconN: PoliciesNotNavIcon },
  { label: 'help', icon: SupportNavIcon, iconN: SupportNotNavIcon },
];
const menuItems2 = [
  { label: 'LIHome', icon: HomeNavIcon, iconN: HomeNotNavIcon },
  { label: 'LIPolicies', icon: PoliciesNavIcon, iconN: PoliciesNotNavIcon },
  { label: 'LIPayment', icon: PaymentNavIcon, iconN: PaymentNotNavIcon },
  { label: 'LIPolicyUp', icon: EditNavIcon, iconN: EditNotNavIcon },
  { label: 'LISupport', icon: SupportNavIcon, iconN: SupportNotNavIcon },
];

// const flag = ['a'];
// const BravoHeaderAvatar = ({ memberType }: { memberType: string }): JSX.Element => {
//   const { ready, token } = useKeycloakReady();
//   const { shouldFetch: fetchProfileImage, data: profileImageData } = useProfileImage(
//     { name: 'getProfileImage', memberType },
//     token ?? '',
//     memberType,
//     {
//       revalidateOnFocus: false,
//       revalidateIfStale: false,
//       revalidateOnReconnect: false,
//     },
//   );

//   const profileImage =
//     !!profileImageData && profileImageData.length > 0
//       ? profileImageData.find((profileImage) => profileImage.memberType === memberType)
//       : undefined;
//   const avatarUrl = profileImage ? profileImage.pictureUrl : '';

//   useEffect(() => {
//     fetchProfileImage(ready && !!memberType);
//   }, [fetchProfileImage, ready, memberType]);

//   return <Avatar avatarUrl={avatarUrl} />;
// };

const BravoHeader = ({ showViewAsUser }: { showViewAsUser?: boolean }): JSX.Element => {
  const [showMask, setShowMask] = useState(false); // State to show mask
  const [ebFlag, setEBFlag] = useState(false); // State to show mask
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { keycloak, tokenParsed, token } = useKeycloakReady();
  const [selectedKey, setSelectedKey] = useState('');
  const [hoverSelected, setHoverSelected] = useState('');
  const [hoverFlag, setHoverFlag] = useState(false);
  const { lg, xl } = useBreakpoint();
  const [showCard, setShowCard] = useState<boolean>(false);
  const [showColNav, setShowColNav] = useState<boolean>(false);
  const {
    data: getData,
    // error: getDataError,
    shouldFetch: shouldFetchGetPopUp,
  } = useGetPopUp('useGetPopUp', token || ''); // Fetch pop-up info
  const {
    // data: postData,
    // error: postDataError,
    shouldFetch: shouldFetchPostPopUp,
  } = usePostPopUp('usePostPopUp', token || '', {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldFetchPostPopUp(false);
      // setIsLoading(false);
    },
    onError: (err: string) => {
      console.log(err);
      shouldFetchPostPopUp(false);
      // setIsLoading(false);
    },
  });

  const { shouldFetch: shouldFetchPostLifePopUp } = usePostLifePopUp('usePostLifePopUp', token || '', {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldFetchPostLifePopUp(false);
    },
    onError: (err: string) => {
      console.log(err);
      shouldFetchPostLifePopUp(false);
    },
  });

  const navigate = useNavigate();
  // const genbravoSessionFlag = sessionStorageService.get('genbravoSessionFlag');

  const isLogin =
    // genbravoSessionFlag &&
    keycloak.authenticated &&
    !['/we-care-login', '/register/otp-verification', '/migration', '/login'].includes(location?.pathname) &&
    !location?.pathname.includes('/register');
  const { state: homeData, dispatch, setShowTips } = useContext(HomeContext);
  const logLogout = useLogLogout({
    sourceOfRequest: window.location.pathname,
    media: 'WEB',
    authToken: keycloak.token,
    device: osName,
    deviceVersion: osVersion,
  });
  const { mutate } = useSWRConfig();
  const [reset, setRest] = useState(false);
  /* eslint-disable */

  useEffect(() => {
    setRest(false);
    return () => {
      setRest(false);
    };
  }, []);
  const isOpen = useCallback(
    (keys) => {
      if (location.pathname === '/addConfirmEb' && keys.includes('Employee Benefits')) {
        return true;
      }
      if (location.pathname === '/addConfirm' && keys.includes('Life Insurance')) {
        return true;
      }
      return false;
    },
    [location],
  );

  useEffect(() => {
    if (getData)
      if (getData.message === 'Y') {
        // eb+life eb失效
        setShowMask(true);
        setEBFlag(true);
        setShowTips(true);
      } else if (getData.message === 'LI') {
        //eb+life life失效
        setShowMask(true);
        setShowTips(true);
      } else {
        setShowTips(false);
      }
  }, [getData]);
  useEffect(() => {
    if (location.pathname === '/addConfirmEb' || location.pathname === '/addConfirm') {
      const childs = document.createElement('div');
      childs.className = 'mask_custom';
      childs.style.position = 'fixed';
      childs.style.height = '100%';
      childs.style.width = '100%';
      childs.style.top = '0';
      childs.style.left = '0';
      childs.style.zIndex = '130';
      childs.style.backgroundColor = 'rgba(0,0,0,.2)';
      document.body.appendChild(childs);
      if (reset) {
        const child = document.getElementsByClassName('mask_custom');
        child &&
          Array.from(child).forEach((v) => {
            document.body.removeChild(v);
          });
      }
    }
  }, [reset, location]);
  const menuItemFirst = useMemo(() => {
    return [
      {
        flag: 'Employee Benefits',
        title: 'ebnav',
        tip: reset ? false : isOpen('Employee Benefits'),
        children: [
          {
            path: '/addConfirmEb',
            title: 'addConfirmEb',
          },
          {
            path: '/ProfileConnectLife',
            title: 'ProfileConnectLife',
          },
        ],
      },
      {
        flag: 'Life Insurance',
        title: 'linav',
        tip: reset ? false : isOpen('Life Insurance'),
        children: [
          {
            path: '/LifeInbox',
            title: 'LifeInbox',
          },
          {
            path: '/addConfirm',
            title: 'addConfirm',
          },
          {
            path: '/LifeAccount',
            title: 'LifeAccount',
          },
          {
            path: '/PoliciesDetail',
            title: 'PoliciesDetail',
          },
          {
            path: '/PoliciesValues',
            title: 'PoliciesValues',
          },
          {
            path: '/beneficiaries',
            title: 'beneficiaries',
          },
          {
            path: '/PoliciesCorrespondence',
            title: 'PoliciesCorrespondence',
          },
          {
            path: '/PoliciesCorrespondence',
            title: 'PoliciesCorrespondence',
          },
        ],
      },
    ];
  }, [location, isOpen, reset]);

  // const { state: data } = useProfileInfoContext();
  const firstNav = useMemo(() => {
    return tokenParsed?.ebClientKey !== '' && tokenParsed?.ilClientKey !== ''
      ? menuItemFirst
      : tokenParsed?.ebClientKey !== ''
      ? [menuItemFirst[0]]
      : [menuItemFirst[1]];
  }, [tokenParsed, menuItemFirst]);

  // const getSelectedKey = () => {
  //   if (menuItems.every((name) => !location.pathname.includes(name))) {
  //     return '';
  //   }

  //   return selectedKey;
  // };

  const handleMenuClick = ({ key }: MenuInfo) => {
    key === selectedKey ? setShowCard(!showCard) : setShowCard(true);
    setSelectedKey(key);
  };

  const getItemsFirst = useCallback(() => {
    return firstNav.map((menuItem, index) =>
      // if (menuItem == 'Employee Benefits') {
      ({
        key: `${menuItem.flag}-${index}`,
        label: (
          <Popover
            placement="topLeft"
            content={
              <div>
                <span style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072' }}>
                  {t('life.register.Quicktip')}
                </span>
                <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B' }}>
                  {t('life.register.Quicktiptext')}
                </p>
                <p
                  style={{
                    textAlign: 'right',
                    fontSize: 17,
                    color: '#420252B',
                    marginBottom: '0px',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setRest(true);
                  }}
                >
                  {i18n.language == 'en' ? 'close' : '關閉'}
                </p>
              </div>
            }
            open={menuItem.tip}
          >
            <div
              onMouseEnter={() => {
                setHoverFlag(true);
                setHoverSelected(menuItem.flag);
                setShowCard(true);
              }}
              onMouseLeave={() => {
                setShowCard(false);
              }}
            >
              {t(`life.guide.${menuItem.title}`)}
            </div>
          </Popover>
        ),
        // children: menuItems,

        // } else
        //   return {
        //     key: `${menuItem}-${index}`,
        //     label: <div>{menuItem}</div>,
        //     children: menuItems2,
        //   };
      }),
    );
  }, [firstNav, t, isOpen]);

  const getSelectedKeyFirst = useCallback(() => {
    // const menuList = selectedKey.includes('Employee Benefits') ? menuItems : menuItems2;
    // if (menuList.every((menu) => !location.pathname.includes(menu.label))) {
    //   return '';
    // }
    let key = getItemsFirst()[0].key;
    if (menuItems.some((menu) => location.pathname.includes(menu.label))) {
      key =
        // getItemsFirst().filter((item) => item.key.includes(i18n.language == 'en' ? 'Employee Benefits' : '團體醫療'))[0]
        //   ?.key || '';
        getItemsFirst().filter((item) => item.key.includes('Employee Benefits'))[0]?.key || '';
    } else if (menuItems2.some((menu) => location.pathname.includes(menu.label))) {
      key =
        // getItemsFirst().filter((item) => item.key.includes(i18n.language == 'en' ? 'Life Insurance' : '人壽保險'))[0]
        //   ?.key || '';
        getItemsFirst().filter((item) => item.key.includes('Life Insurance'))[0]?.key || '';
    } else key = '';

    let extraKey = '';
    menuItemFirst.forEach((item) => {
      if (item.children && item.children.length > 0) {
        const find = item.children.find((d) => d.path === location.pathname);
        if (find) {
          extraKey = getItemsFirst().filter((item1) => item1.key.includes(item.flag))[0]?.key;
        }
      }
    });
    return extraKey || key;
  }, [getItemsFirst, location]);
  /* eslint-enable*/

  // Refer to: Usage upgrade after 4.20.0 (https://ant.design/components/menu/#Usage-upgrade-after-4.20.0)
  // const getItems = () => {
  //   return menuItems.map((menuItem, index) => ({
  //     key: `${menuItem}-${index}`,
  //     label:
  //       menuItem === 'help' ? (
  //         <Dropdown overlay={<HelpMenu />} trigger={['click']}>
  //           <Typography.Link>{t('header.help')} </Typography.Link>
  //         </Dropdown>
  //       ) : (
  //         <Link to={`/${menuItem}`}>{t(`header.${menuItem}`)}</Link>
  //       ),
  //   }));
  // };

  const Brief = (): JSX.Element => {
    const currentKey = hoverFlag
      ? hoverSelected.includes('Employee Benefits')
      : selectedKey.includes('Employee Benefits');
    const brief = currentKey ? t('life.guide.ebBrief') : t('life.guide.liBrief');
    return (
      <BriefWrapper>
        <div style={{ maxWidth: '178px', margin: 'auto' }}>
          <p className="title">
            {currentKey ? t(`life.guide.${menuItemFirst[0].title}`) : t(`life.guide.${menuItemFirst[1].title}`)}
          </p>
          <p className="brief">{brief}</p>
        </div>
      </BriefWrapper>
    );
  };
  const dropdownRef = useRef<HTMLDivElement>(null);
  // 监听全局点击事件
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowCard(false);
      }
    };

    setRest(false);
    document.addEventListener('click', handleClick, true); // 第三个参数设置为true，表示在捕获阶段监听事件
    return () => {
      document.removeEventListener('click', handleClick, true);
      setRest(false);
    };
  }, []);
  /* eslint-disable */
  useEffect(() => {
    const unregister = () => {
      // 路由变化时的处理逻辑
      console.log(`The route has changed to ${location.pathname}`);
      if (location.pathname === '/LIHome') {
        shouldFetchGetPopUp(true);
      } else if (location.pathname === '/home') {
        shouldFetchGetPopUp(true);
      }
      if (!lg && isLogin) {
        setShowColNav(false);
      }
      if (tokenParsed && !tokenParsed?.ebClientKey && tokenParsed?.ilClientKey !== '' && location.pathname == '/home')
        navigate('/LIHome');
      getSelectedKeyFirst();
    };
    unregister();

    return () => {
      // 组件卸载时取消监听
    };
  }, [location, tokenParsed]);
  const BravoCardNav = (): JSX.Element => {
    const [hoveredHelp, setHoveredHelp] = useState(false);
    const [hovered, setHovered] = useState(false);
    const handleMouseEnter = (menu: { label: string; icon: string }) => {
      if (menu.label == 'LISupport') setHovered(true);
      else if (menu.label == 'help') setHoveredHelp(true);
    };

    const handleMouseLeave = (menu: { label: string; icon: string }) => {
      if (menu.label == 'LISupport') setHovered(false);
      else if (menu.label == 'help') setHoveredHelp(false);
    };
    const menuList = hoverFlag
      ? hoverSelected.includes('Employee Benefits')
        ? menuItems
        : menuItems2
      : selectedKey.includes('Employee Benefits')
      ? menuItems
      : menuItems2;
    const list = menuList.map((menu, index) => {
      return menu.label === 'help' ? (
        <Dropdown overlay={<HelpMenu />} trigger={['click']} key={index}>
          <Typography.Link onMouseEnter={() => handleMouseEnter(menu)} onMouseLeave={() => handleMouseLeave(menu)}>
            <div
              className={`hover-active ${location.pathname.includes(menu.label) ? 'selected' : ''}`}
              style={{ maxWidth: '178px', margin: 'auto', color: '#000' }}
            >
              <div className={'svg-color'}>
                <img src={menu.iconN} alt="Normal" className="normal-image" width={24} height={24} />
                <img src={menu.icon} alt="Hover" className="hover-image" width={24} height={24} />
                {/* {hoveredHelp && <img src={menu.icon} alt="" />}
                {!hoveredHelp && <img src={SupportNotNavIcon} alt="" />} */}
              </div>
              <span className="font-set">{t('header.help')}</span>
              <p style={{ marginTop: '5px', fontSize: '15px' }}>{t(`life.guide.${menu.label}`)}</p>
            </div>
          </Typography.Link>
        </Dropdown>
      ) : (
        <Fragment key={index}>
          <Link
            to={`/${menu.label}`}
            onMouseEnter={() => handleMouseEnter(menu)}
            onMouseLeave={() => handleMouseLeave(menu)}
          >
            <div
              className={`hover-active ${location.pathname.includes(menu.label) ? 'selected' : ''}`}
              style={{ maxWidth: '178px', margin: 'auto' }}
            >
              <div className={'svg-color'}>
                <img src={menu.iconN} alt="Normal" className="normal-image" width={24} height={24} />
                <img src={menu.icon} alt="Hover" className="hover-image" width={24} height={24} />
                {/* {menu.label == 'LISupport' &&
                  (hovered || location.pathname.includes(menu.label) ? (
                    <img src={menu.icon} alt="" />
                  ) : (
                    <img src={SupportNotNavIcon} alt="" />
                  ))}
                {menu.label != 'LISupport' && <img src={menu.icon} alt="" />} */}
              </div>
              <span className="font-set">{t(`header.${menu.label}`)}</span>
              <p style={{ marginTop: '5px', fontSize: '15px' }}>{t(`life.guide.${menu.label}`)}</p>
            </div>
          </Link>
          {index < menuList.length - 1 && <CardStyledDivider style={{ marginTop: '18px' }} type="vertical" />}
        </Fragment>
      );
    });
    return (
      <DropCard
        className="drop-card"
        ref={dropdownRef}
        onMouseEnter={() => {
          setShowCard(true);
        }}
        onMouseLeave={() => {
          setShowCard(false);
        }}
      >
        <Brief></Brief>
        <CardStyledDivider type="vertical" />
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'flex-start' }}>
          {list}
        </div>
      </DropCard>
    );
  };
  const changeShowColNav = (status: boolean) => {
    setShowColNav(status);
  };
  const news = _.get(homeData, 'userAccess.reminders[0]');
  const patchReminder = usePatchReminder(keycloak.token || '', news?.id || 0);

  type Key = SessionStorageKey | `${SessionStorageKey}`;

  const removeStorge = () => {
    const storage = sessionStorage;
    if (storage.length > 0) {
      storage.forEach((key: Key) => {
        if (key != 'i18nLanguage') sessionStorageService.remove(key);
      });
    }
  };
  const onLogoutPressed = async () => {
    try {
      news?.id && (await patchReminder());
      sessionStorageService.clear();
      removeCookie('KeycloakTokens');
      // await removeStorge();
      await logLogout();
      await mutate(() => true, undefined, { revalidate: false });
    } catch (error) {
      //   // TODO: show a https://ant.design/components/notification/ ?
      //   // console.log('onLogoutPressed()->Error occurred', error);
    }

    await keycloak.logout();
    dispatch({ type: UserAccessActionTypes.LOGOUT });
  };

  return (
    <StyledWrapper isLogin={location?.pathname.includes('login')} className="life-home">
      <StyledHeader
        style={
          location?.pathname.includes('login') && !location?.pathname.includes('forgot')
            ? {
                backgroundColor: 'transparent',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }
            : location?.pathname.includes('forgot') || location?.pathname.includes('register')
            ? {
                backgroundColor: '#C21B17',
              }
            : xl
            ? { width: '100%', margin: '0 auto' }
            : { maxWidth: '1384px', margin: '0 auto' }
        }
      >
        {/* <StyledHeader style={{ maxWidth: '1384px', margin: '0 auto' }}> */}
        <div className="menu-nav-wrapper">
          <img
            src={logo}
            alt=""
            width="200"
            height="27"
            style={{ display: location?.pathname.includes('login') ? 'none' : 'block' }}
          />
          {lg && isLogin && (
            <Menu
              className="menu-nav"
              selectedKeys={[getSelectedKeyFirst()]}
              onClick={handleMenuClick}
              mode="horizontal"
              disabledOverflow
              items={getItemsFirst()}
            ></Menu>
          )}
        </div>
        {showMask && (
          <div
            className="mask"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 9999,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div style={{ background: 'white', paddingLeft: 24, paddingRight: 24, borderRadius: 8 }}>
              <span style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072' }}>
                {t('life.register.Quicktip')}
              </span>
              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B' }}>
                {ebFlag ? t('life.home.note1') : t('life.home.note')}
              </p>
              <p
                style={{ textAlign: 'right', fontSize: 17, color: '#420252B', marginBottom: '0px', cursor: 'pointer' }}
                onClick={() => {
                  setShowMask(false);
                  setShowTips(false);
                  if (ebFlag) {
                    shouldFetchPostPopUp(true); //點擊關閉eb失效彈窗
                  } else {
                    shouldFetchPostLifePopUp(true); //點擊關閉life失效彈窗
                  }
                }}
              >
                {i18n.language == 'en' ? 'close' : '關閉'}
              </p>
            </div>
          </div>
        )}
        <div style={{ position: 'absolute', top: 36, left: `calc(50% - 100px)` }}>
          <img
            src={logo2}
            alt=""
            width="200"
            height="27"
            style={{
              display:
                location?.pathname.includes('login') ||
                location?.pathname.includes('register') ||
                location?.pathname.includes('forgot')
                  ? 'block'
                  : 'none',
            }}
          />
        </div>
        {!lg && !isLogin && <MobileLang></MobileLang>}
        {lg && !location?.pathname.includes('genbravo/payment/return') && (
          <MenuWrapper className={lg && 'bravo-header'} size={16} lg={lg}>
            {/* {!(location?.pathname.includes('register') || location?.pathname.includes('forgot')) && ( */}
            <LanguageSelector
              white={
                location?.pathname.includes('login') ||
                location?.pathname.includes('register') ||
                location?.pathname.includes('forgot')
                  ? true
                  : false
              }
            />
            {/*  )} */}
            {/* Hidden props disabledOverflow */}
            {isLogin && (
              <>
                {/* <StyledDivider type="vertical" />
                <Dropdown overlay={<ProfileMenu />} trigger={['click']}>
                  <div>
                    <BravoHeaderAvatar memberType={data?.memberType ?? ''} />
                  </div>
                </Dropdown>
                <InboxButton /> */}
                <LogoutButtonIcon onClick={onLogoutPressed} />
              </>
            )}
          </MenuWrapper>
        )}
        {!lg && isLogin && (
          // <MenuWrapper>
          //   <Dropdown
          //     overlay={
          //       <Menu
          //         items={[
          //           ...(isLogin ? getItems().filter((o) => o.key !== 'help-4') : []),
          //           ...(isLogin ? getHelpMenuItems(t) || [] : []),
          //           ...(isLogin
          //             ? [
          //                 {
          //                   key: 'profile',
          //                   label: (
          //                     <Space size={25}>
          //                       <Link to="/profile">
          //                         <Avatar avatarUrl={data?.pictureUrl} />
          //                       </Link>
          //                       <InboxButton />
          //                     </Space>
          //                   ),
          //                 },
          //               ]
          //             : []),
          //           {
          //             key: 'lang',
          //             label: <LanguageSelector />,
          //           },
          //         ]}
          //       />
          //     }
          //     trigger={['click']}
          //   >
          //     <img src={MobileMenuIcon} alt="mobile menu" />
          //   </Dropdown>
          // </MenuWrapper>
          <CollapseNav status={showColNav} changeShowColNav={changeShowColNav} showViewAsUser={showViewAsUser}></CollapseNav>
        )}
        {location?.pathname.includes('genbravo/payment/return') && <AppLang></AppLang>}
      </StyledHeader>
      {showCard && lg && <BravoCardNav></BravoCardNav>}
    </StyledWrapper>
  );
};

export default BravoHeader;
